export var ManualWithdrawType;
(function (ManualWithdrawType) {
    ManualWithdrawType["WITHDRAW"] = "manual_withdraw";
    ManualWithdrawType["EVENT"] = "manual_event";
    ManualWithdrawType["OTHER"] = "manual_other";
    ManualWithdrawType["RISK_ADJUSTMENT"] = "manual_risk_adjustment";
})(ManualWithdrawType || (ManualWithdrawType = {}));
//# sourceMappingURL=ManualWithdrawType.js.map